import {
	ApolloClient,
	ApolloLink,
	HttpLink,
	InMemoryCache,
	Observable,
	split,
} from '@apollo/client';
import { WebSocketLink } from '@apollo/client/link/ws';
// import { InMemoryCache } from 'apollo-cache-inmemory';
// import { ApolloLink, Observable, split } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { TokenRefreshLink } from 'apollo-link-token-refresh';
import { createUploadLink } from 'apollo-upload-client';
import { getMainDefinition } from 'apollo-utilities';
import jwtDecode from 'jwt-decode';
import { getAccessToken, setAccessToken } from './AccessToken';

let posNodeUrl;
switch (process.env.REACT_APP_ENV) {
	case 'promenade-staging':
		posNodeUrl = 'https://menuxapi-promenade-uat.menux.asia/menux-graphql';
		break;
	case 'promenade':
		posNodeUrl = 'https://menuxapi-promenade.menux.asia/menux-graphql';
		break;
	case 'imperial-staging':
		posNodeUrl = 'https://menuxapi-imperial-uat.menux.asia/menux-graphql';
		break;
	case 'imperial':
		posNodeUrl = 'https://menuxapi-imperial.menux.asia/menux-graphql';
		break;
	case 'swan':
		posNodeUrl = 'https://menuxswanapi.menux.asia/menux-graphql';
		break;
	case 'edu':
		posNodeUrl = 'https://menuxapi-edu.menux.asia/menux-graphql';
		break;
	case 'local':
		posNodeUrl = 'http://localhost:9000/menux-graphql';
		break;
	case 'dev':
		posNodeUrl = 'https://posx-dev-api.ifca.io/menux-graphql';
		break;
	case 'uat':
		posNodeUrl = 'https://menux-uat-api.menux.asia/menux-graphql';
		break;
	case 'pkns-uat':
		posNodeUrl = 'https://pos-uat-api.menux.asia/menux-graphql';
		break;
	case 'pkns':
		posNodeUrl = 'https://pos-api.menux.asia/menux-graphql';
		break;
	default:
		posNodeUrl = 'https://menuxapi.menux.asia/menux-graphql';
		break;
}

let wsNodeUrl;
switch (process.env.REACT_APP_ENV) {
	case 'promenade-staging':
		wsNodeUrl = 'wss://menuxapi-promenade-uat.menux.asia/menux-graphql';
		break;
	case 'promenade':
		wsNodeUrl = 'wss://menuxapi-promenade.menux.asia/menux-graphql';
		break;
	case 'imperial-staging':
		wsNodeUrl = 'wss://menuxapi-imperial-uat.menux.asia/menux-graphql';
		break;
	case 'imperial':
		wsNodeUrl = 'wss:/menuxapi-imperial.menux.asia/menux-graphql';
		break;
	case 'swan':
		wsNodeUrl = 'wss:/menuxswanapi.menux.asia/menux-graphql';
		break;
	case 'edu':
		wsNodeUrl = 'wss:/menuxapi-edu.menux.asia/menux-graphql';
		break;
	case 'local':
		wsNodeUrl = 'ws://localhost:9000/menux-graphql';
		break;
	case 'dev':
		wsNodeUrl = 'wss://posx-dev-api.ifca.io/menux-graphql';
		break;
	case 'uat':
		wsNodeUrl = 'wss://menux-uat-api.menux.asia/menux-graphql';
		break;
	case 'pkns-uat':
		wsNodeUrl = 'wss://pos-uat-api.menux.asia/menux-graphql';
		break;
	case 'pkns':
		wsNodeUrl = 'wss://pos-api.menux.asia/menux-graphql';
		break;
	default:
		wsNodeUrl = 'wss://menuxapi.menux.asia/menux-graphql';
		break;
}

export const posNodeRefreshUrl =
	process.env.REACT_APP_ENV === 'promenade-staging'
		? 'https://menuxapi-promenade-uat.menux.asia/refresh_token_menu'
		: process.env.REACT_APP_ENV === 'promenade'
		? 'https://menuxapi-promenade.menux.asia/refresh_token_menu'
		: process.env.REACT_APP_ENV === 'imperial-staging'
		? 'https://menuxapi-imperial-uat.menux.asia/refresh_token_menu'
		: process.env.REACT_APP_ENV === 'imperial'
		? 'https://menuxapi-imperial.menux.asia/refresh_token_menu'
		: process.env.REACT_APP_ENV === 'swan'
		? 'https://menuxswanapi.menux.asia/refresh_token_menu'
		: process.env.REACT_APP_ENV === 'edu'
		? 'https://menuxapi-edu.menux.asia/refresh_token_menu'
		: process.env.REACT_APP_ENV === 'local'
		? 'http://localhost:9000/refresh_token_menu'
		: process.env.REACT_APP_ENV === 'dev'
		? 'https://posx-dev-api.ifca.io/refresh_token_menu'
		: process.env.REACT_APP_ENV === 'uat'
		? 'https://menux-uat-api.menux.asia/refresh_token_menu'
		: process.env.REACT_APP_ENV === 'pkns-uat'
		? 'https://pos-uat-api.menux.asia/refresh_token_menu'
		: process.env.REACT_APP_ENV === 'pkns'
		? 'https://pos-api.menux.asia/refresh_token_menu'
		: 'https://menuxapi.menux.asia/refresh_token_menu';
// 'http://localhost:9000/refresh_token_menu';

const cache = new InMemoryCache({});

//Getting access Token and passing it in request headers
const requestLink = new ApolloLink(
	(operation, forward) =>
		new Observable(observer => {
			let handle: any;
			Promise.resolve(operation)
				.then(operation => {
					const accessToken = getAccessToken();
					if (accessToken) {
						operation.setContext({
							headers: {
								authorization: `bearer ${accessToken}`,
							},
						});
					} //accessToken is defined
				}) //then operation ends here
				.then(() => {
					handle = forward(operation).subscribe({
						next: observer.next.bind(observer),
						error: observer.error.bind(observer),
						complete: observer.complete.bind(observer),
					}); //handle ends here
				})
				.catch(observer.error.bind(observer));

			return () => {
				if (handle) handle.unsubscribe();
			};
		}),
);

const uploadLink = createUploadLink({
	uri: posNodeUrl,
	credentials: 'include',
});

const httplink = new HttpLink({
	uri: posNodeUrl,
	credentials: 'include',
}); //new HttpLink ends here

const wsLink = new WebSocketLink({
	uri: wsNodeUrl,
	options: {
		reconnect: true,
		timeout: 20000,
		lazy: true,
	},
});

// The split function takes three parameters:
//
// * A function that's called for each operation to execute
// * The Link to use for an operation if the function returns a "truthy" value
// * The Link to use for an operation if the function returns a "falsy" value
const splitLink = split(
	({ query }) => {
		const definition = getMainDefinition(query);
		return (
			definition.kind === 'OperationDefinition' &&
			definition.operation === 'subscription'
		);
	},
	wsLink,
	httplink,
);

export const WSclient = new ApolloClient({
	cache: cache,
	link: splitLink,
});

export const POSClient = new ApolloClient({
	link: ApolloLink.from([
		new TokenRefreshLink({
			accessTokenField: 'accessToken',
			isTokenValidOrUndefined: () => {
				const token = getAccessToken();

				if (!token) {
					return true;
				}

				try {
					const { exp } = jwtDecode(token);
					if (Date.now() >= exp * 1000) {
						return false;
					} else {
						return true;
					}
				} catch (err) {
					console.log(err);
					return false;
				}
			},
			fetchAccessToken: () => {
				return fetch(posNodeRefreshUrl, {
					method: 'POST',
					credentials: 'include',
				});
			},
			handleFetch: accessToken => {
				setAccessToken(accessToken);
			},
			handleResponse: () => {},
			handleError: err => {
				console.warn('Your refresh token is invalid. Try to relogin');
				console.error(err);
			},
		}),
		onError(() => {}),
		requestLink,
		uploadLink as any, // property split as incompatible
		// splitLink,
	]),
	cache,
});
